import React, { FC } from 'react';

import clsx from 'clsx';

import { useProductListFilters } from '@hooks/products-list-fiters';

import { Button } from '@components/common/Button/Button';
import { CloseIcon } from '@components/icons';

import styles from './CategoryFilters.module.scss';

import { CategoryCheckboxGroup } from '../CategoryCheckboxGroup/CategoryCheckboxGroup';
import { CategoryFiltersAccordion } from '../CategoryFiltersAccordion/CategoryFiltersAccordion';
import { CategoryPriceRangeFilter } from '../CategoryPriceRangeFilter/CategoryPriceRangeFilter';

export type CategoryFiltersProps = {
    className?: string;
};

export const CategoryFilters: FC<CategoryFiltersProps> = (props) => {
    const { className } = props;

    const { checkboxFilters, accordionFilters, applyFilters, discardFilters, filtersChips } =
        useProductListFilters();

    return (
        <ul className={clsx(styles.root, className)}>
            {checkboxFilters.length > 0 && (
                <li className={styles.block}>
                    <CategoryCheckboxGroup data={checkboxFilters} />
                </li>
            )}
            <li className={styles.block}>
                <CategoryPriceRangeFilter />
            </li>
            {(accordionFilters.countries.length > 0 ||
                accordionFilters.manufacturers.length > 0) && (
                <li className={styles.block}>
                    <CategoryFiltersAccordion data={accordionFilters} />
                </li>
            )}

            <li className={styles.controlsBlock}>
                <Button onClick={() => applyFilters()} variant="green" isFullWith>
                    Применить
                </Button>

                {filtersChips.length > 0 && (
                    <Button
                        variant="white"
                        onClick={() => discardFilters()}
                        isFullWith
                        icon={CloseIcon}
                        classes={{ icon: styles.resetIcon }}
                    >
                        Сбросить фильтры
                    </Button>
                )}
            </li>
        </ul>
    );
};
